import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class AdditionalRequestedConditionalValuation {
	constructor(doc) {
		this.additionalOpinionOfValueAmount = null;
		this.marketingOrExposureDaysCount = null
		this.marketingOrExposureHighRangeDaysCount = null
		this.marketingOrExposureLowRangeDaysCount = null
		this.marketingOrExposureTimeType = null
		this.propertyValuationConditionalConclusionType = null

		this.additionalOpinionOfValueAmount  = x.getMISMOAmountElement(doc, "./ns:AdditionalOpinionOfValueAmount");
		this.marketingOrExposureDaysCount = x.getIntegerElement(doc, "./ns:MarketingOrExposureDaysCount");
		this.marketingOrExposureHighRangeDaysCount = x.getIntegerElement(doc, "./ns:MarketingOrExposureHighRangeDaysCount");
		this.marketingOrExposureLowRangeDaysCount = x.getIntegerElement(doc, "./ns:MarketingOrExposureLowRangeDaysCount");
		this.marketingOrExposureTimeType = x.getStringElement(doc, "./ns:MarketingOrExposureTimeType");
		this.propertyValuationConditionalConclusionType = x.getStringElement(doc, "./ns:PropertyValuationConditionalConclusionType");
		}

	GetExposureTime() {
		const exposure = this.marketingOrExposureDaysCount ?? 0;
		if (exposure !== 0)	return `${exposure} days`;

		const lowRange = this.marketingOrExposureLowRangeDaysCount;
		const highRange = this.marketingOrExposureHighRangeDaysCount;
		return `${lowRange}-${highRange} days`;
	}

}

export class ValuationReconciliationDetail {
	constructor(doc)
		{
		this.additionalClientRequestedConditionsCommentDescription = null
		this.additionalClientRequestedConditionsIndicator = null
		this.FHA_REOInsurabilityLevelCode = null
		this.valuationReconciliationSummaryCommentDescription = null

		this.additionalClientRequestedConditionsCommentDescription = x.getStringElement(doc, "./ns:AdditionalClientRequestedConditionsCommentDescription");
		this.additionalClientRequestedConditionsIndicator = x.getBooleanElement(doc, "./ns:AdditionalClientRequestedConditionsIndicator");
		this.FHA_REOInsurabilityLevelCode = x.getStringElement(doc, "./ns:FHA_REOInsurabilityLevelCode");
		this.valuationReconciliationSummaryCommentDescription = x.getStringElement(doc, "./ns:ValuationReconciliationSummaryCommentDescription");
				}
		}

export class ValuationCondition {
	constructor(doc)
		{
		this.propertyValuationConditionalConclusionType = null
		this.propertyValuationConditionalConclusionTypeOtherDescription = null

		this.propertyValuationConditionalConclusionType = x.getStringElement(doc, "./ns:PropertyValuationConditionalConclusionType");
		this.propertyValuationConditionalConclusionTypeOtherDescription = x.getStringElement(doc, "./ns:PropertyValuationConditionalConclusionTypeOtherDescription");
		}

	GetConclusionType()
		{
			//console.log("conclusion: ",this.propertyValuationConditionalConclusionType, this.propertyValuationConditionalConclusionTypeOtherDescription);
			return h.descriptionOrOther(this.propertyValuationConditionalConclusionType, this.propertyValuationConditionalConclusionTypeOtherDescription);
		}

}

export class ValuationReconciliationSummaryDetail {
		constructor(doc)
			{
				this.appraisalReportEffectiveDate = null
				this.lineOfCreditProRataShareSelectionMethodType = null
				this.marketingOrExposureDaysCount = null
				this.marketingOrExposureHighRangeDaysCount = null
				this.marketingOrExposureLowRangeDaysCount = null
				this.marketingOrExposureTimeType = null
				this.opinionOfValueAmount = null;
				this.propertyAsIsConditionRatingCode = null

				this.appraisalReportEffectiveDate = x.getMISMODateElement(doc, "./ns:AppraisalReportEffectiveDate");
				this.lineOfCreditProRataShareSelectionMethodType = x.getStringElement(doc, "./ns:LineOfCreditProRataShareSelectionMethodType");
				this.marketingOrExposureDaysCount = x.getIntegerElement(doc, "./ns:MarketingOrExposureDaysCount");
				this.marketingOrExposureHighRangeDaysCount = x.getIntegerElement(doc, "./ns:MarketingOrExposureHighRangeDaysCount");
				this.marketingOrExposureLowRangeDaysCount = x.getIntegerElement(doc, "./ns:MarketingOrExposureLowRangeDaysCount");
				this.marketingOrExposureTimeType = x.getStringElement(doc, "./ns:MarketingOrExposureTimeType");
				this.opinionOfValueAmount  = x.getMISMOAmountElement(doc, "./ns:OpinionOfValueAmount");
				this.propertyAsIsConditionRatingCode = x.getStringElement(doc, "./ns:PropertyAsIsConditionRatingCode");
			}
		}

export class ValuationReconciliationSummary {
	constructor(doc) {
		this.valuationConditions = [];
		this.valuationReconciliationSummaryDetail = null;
		var node;
		var nodes;

		nodes = x.selectNodes(doc, "./ns:VALUATION_CONDITIONS/ns:VALUATION_CONDITION");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.valuationConditions.push(new ValuationCondition(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:VALUATION_RECONCILIATION_SUMMARY_DETAIL");
		if (node !== null)
			this.valuationReconciliationSummaryDetail =
				new ValuationReconciliationSummaryDetail(node);
	}

	GetExposureTime() {
		const exposure = this.valuationReconciliationSummaryDetail.marketingOrExposureDaysCount ?? 0;
		if (exposure !== 0)	return `${exposure} days`;

		const lowRange = this.valuationReconciliationSummaryDetail.marketingOrExposureLowRangeDaysCount;
		const highRange = this.valuationReconciliationSummaryDetail.marketingOrExposureHighRangeDaysCount;
		return `${lowRange}-${highRange} days`;
	}

	ConditionsContain(tag) {
		return this.valuationConditions.some(condition =>
			condition.propertyValuationConditionalConclusionType === tag);
	}
}

export class ValuationReconciliation {
	constructor(doc)
		{
		this.additionalRequestedConditionalValuations = []
		this.valuationReconciliationDetail = null
		this.valuationReconciliationSummary = null
		var node;
		var nodes;

		nodes = x.selectNodes(doc, "./ns:ADDITIONAL_REQUESTED_CONDITIONAL_VALUATIONS/ns:ADDITIONAL_REQUESTED_CONDITIONAL_VALUATION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.additionalRequestedConditionalValuations.push(new AdditionalRequestedConditionalValuation(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:VALUATION_RECONCILIATION_DETAIL");
		if (node !== null)
				this.valuationReconciliationDetail = new ValuationReconciliationDetail(node);
		node = x.selectSingleNode(doc, "./ns:VALUATION_RECONCILIATION_SUMMARY");
		if (node !== null)
				this.valuationReconciliationSummary = new ValuationReconciliationSummary(node);
		}

ConditionalConclusionExists(conclusion) {
    if (this.valuationReconciliationSummary && this.valuationReconciliationSummary.valuationConditions) {
        for (const val of this.valuationReconciliationSummary.valuationConditions) {
            if (val.lineOfCreditProRataShareSelectionMethodTyperopertyValuationConditionalConclusionType === conclusion) return true;
        }
    }
    return false;
}

GetValuationConditionsList() {
    var list = [];
    if (this.valuationReconciliationSummary && this.valuationReconciliationSummary.valuationConditions) {
        for (const condition of this.valuationReconciliationSummary.valuationConditions) {
            list.push(condition.GetConclusionType());
        }
    }
    return list;
}

GetValuationConditions() {
    let conditions = '';
    if (this.valuationReconciliationSummary && this.valuationReconciliationSummary.valuationConditions) {
        for (const condition of this.valuationReconciliationSummary.valuationConditions) {
            conditions = conditions.AddWithSpace(condition.propertyValuationConditionalConclusionType);
        }
    }
    return conditions;
}

GetFinalValueConditionStatement() {
    let conditions = "";

    if (this.valuationReconciliationSummary && this.valuationReconciliationSummary.valuationConditions) {
        for (const condition of this.valuationReconciliationSummary.valuationConditions) {
            const type = condition.propertyValuationConditionalConclusionType;
						if (!type) return "";

				    conditions = "This appraisal is made "
            switch(type) {
                case "SubjectToCompletionPerPlans":
                    conditions += "subject to completion per plans and specifications on the basis of a hypothetical condition that the improvements have been completed.";
                    break;
                case "SubjectToInspection":
                    conditions += "subject to the itemized list of required inspections below based on the extraordinary assumption that the condition or deficiency does not require alteration or repair.";
                    break;
                case "SubjectToRepair":
                    conditions += "subject to the itemized list of repairs or alterations recommended below on the basis of a hypothetical condition that the repairs or alterations have been completed in a professional manner.";
                    break;
                // Removed by UMDP 9/24
                // case "SubjectToExtraordinaryAssumptions":
                //     conditions = conditions.AddWithSpacer(" subject to the extraordinary assumption that ", ", and");
                //     conditions += condition.valuationReconciliationConditionsCommentDescription;
                //     break;
                // case "SubjectToHypotheticalConditions":
                //     conditions = conditions.AddWithSpacer(" subject to the hypothetical condition that ", ", and");
                //     conditions += condition.valuationReconciliationConditionsCommentDescription;
                //     break;
								default:
									return "";
            }
        }
        conditions += " This might have affected the assignment results.";
    }
    return conditions;
	}
}

